import a from"styled-components";import{theme as r}from"../../../theme.js";const e=a.div`
  display: flex;
  align-items: center;
  gap: ${r.spacing*4}px;
  flex-wrap: wrap;
  width: fit-content;
  @media screen and (max-width: ${r.breakpoints.md}) {
    width: calc(100vw - 32px);
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    flex-wrap: nowrap;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`,n=a.button`
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  outline: none;
  border: none;
  padding: ${r.spacing*3}px ${r.spacing*6}px;
  border-radius: ${r.radius}px;
  background-color: ${({active:o})=>o?r.colors.primary[50]:r.colors.gray[50]};
  color: ${({active:o})=>o?r.colors.primary[500]:r.colors.gray[900]};
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    background-color: ${({active:o})=>o?r.colors.primary[50]:r.colors.gray[100]};
  }
  @media screen and (max-width: ${r.breakpoints.md}) {
    scroll-snap-stop: always;
    scroll-snap-align: center;
  }
`;export{e as Container,n as Tab};
